/* eslint-disable */

/**
 * The HTML template of a tweet
 * @param {String} time The time of the tweet
 * @param {String} text The text of the tweet
 * @param {String} imgUrl The url img of the tweet
 * @returns
 */
const template = (
  displayAction,
  time,
  text,
  textForShare,
  trad,
  index,
  imgUrl,
  imgAlt
) => {
  const img = imgUrl
    ? `<div class="illust"><img src=${imgUrl} alt="${imgAlt}"></div>`
    : "";

  const btnContainer = displayAction
    ? `<div class="btn-container">
          <a class="btn-twitter-share" href="https://twitter.com/intent/tweet/?text=${textForShare}" target="_blank" rel="noopener" title="${trad.labelShare}"  aria-label="${trad.labelShare}">
              <svg class="icon-twitter">
                  <use xlink:href="#icon-twitter"></use>
              </svg>
          </a>
          <button class="copy" type="button" aria-labelledby="content-${index}">
              <svg class="icon-copy">
                  <use xlink:href="#icon-copy"></use>
              </svg>
              ${trad.labelBtn}
              <span class="info-bubble">${trad.labelBubble}</span>
          </button>
      </div>`
    : "";

  const tweetTemplate = `<div class="tweet">
              <div class="header-content">
                  <span class="time">${time}</span>
                  ${btnContainer}
              </div>
              <p id="content-${index}" class="text-content">
                  ${text}
              </p>
              ${img}
          </div>`;

  return tweetTemplate;
};

export default template